<template>
  <v-container>
    <v-row no-gutters class="mb-2">
      <Prompt
        v-if="getIsAdmin"
        activator-text="Nouvelle Raison"
        activator-icon="fa-plus"
        activatorIconSize="small"
        inputText="Nouvelle Raison"
        errorMessage="Une raison est requise"
        text
        color="success"
        @submit="createWasteCause"
      >
      </Prompt>
    </v-row>
    <v-card>
      <v-card-text>
        <InventoryWasteGrid :loading="loading"></InventoryWasteGrid>
      </v-card-text>
    </v-card> </v-container
></template>

<script>
import { InventoryWasteGrid } from "../components";
import { mapGetters } from "vuex";
export default {
  name: "InventoryWasteCauseIndex",
  components: {
    InventoryWasteGrid
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  computed: {
    ...mapGetters(["getIsAdmin", "getStoreId", "getOrganisationId"])
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        await Promise.all([
          this.$store.dispatch("loadWasteCauses", {
            store: this.getStoreId
          })
        ]);
      } finally {
        this.loading = false;
      }
    },
    async createWasteCause(name) {
      if (name) {
        const data = {
          name: name,
          store: this.getStoreId
        };
        try {
          this.$store.dispatch("slo");
          await this.$store.dispatch("addWasteCause", data);
        } finally {
          this.$store.dispatch("elo");
        }
      }
    }
  },
  watch: {
    getStoreId() {
      this.getData();
    },
    getOrganisationId() {
      this.getData();
    }
  }
};
</script>

<style></style>
